/* eslint-disable no-shadow */
const state = {
  allTeachers: Array,
  followingTeachers: []
};

const getters = {
  getAllTeachers: state => state.allTeachers,
  getFollowingTeachers: state => state.followingTeachers
};

const mutations = {
  setAllTeachersMutation: (state, payload) => {
    state.allTeachers = payload;
  },
  setFollowingTeachersMutation: (state, payload) => {
    state.followingTeachers = payload;
  }
};

const actions = {
  setAllTeachers: ({ commit }, payload) => {
    commit("setAllTeachersMutation", payload);
  },
  setFollowingTeachers: ({ commit }, payload) => {
    commit("setFollowingTeachersMutation", payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
